"use strict";

import $ from 'jquery';
import { authorIDtoHTML } from './render';

$(function () {
    const queryString = $('#pageSpecificScript').attr('data-queryString');

    $('#philosopherTable').DataTable({
        ajax: {
            'url': '/philosophers.json?' + queryString,
            'type': 'GET',
        },
        columns: [
            { render: authorIDtoHTML }, // ID
            { render: authorIDtoHTML }, // standard name
            null, // Gender
            null, // Birth Year
            null, // # Mentions
        ],
        order: [[4, 'desc']], // descending order on #mentions
    });
});
